import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const AlertFilterLine = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    title="AlertFilterLine"
    {...props}
  >
    <g clipPath="url(#clip0_7_33)">
      <mask
        id="mask0_7_33"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={-4}
        y={-4}
        width={23}
        height={24}
      >
        <rect
          x={6.25068}
          y={-4.09081}
          width={14.29}
          height={19.3464}
          rx={1}
          transform="rotate(30 6.25068 -4.09081)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_7_33)">
        <path
          d="M17.4999 3.33351V5.00017H16.6666L12.4999 11.2502V18.3335H7.49995V11.2502L3.33328 5.00017H2.49995V3.33351H17.4999ZM5.33661 5.00017L9.16661 10.7452V16.6668H10.8333V10.7452L14.6633 5.00017H5.33661Z"
          fill="#394959"
        />
      </g>
    </g>
    <path
      d="M15.3608 11.25L19.33 18.125C19.3666 18.1883 19.3858 18.2602 19.3858 18.3333C19.3858 18.4065 19.3666 18.4783 19.33 18.5417C19.2934 18.605 19.2408 18.6576 19.1775 18.6942C19.1142 18.7307 19.0423 18.75 18.9692 18.75H11.0308C10.9577 18.75 10.8858 18.7307 10.8225 18.6942C10.7592 18.6576 10.7066 18.605 10.67 18.5417C10.6334 18.4783 10.6142 18.4065 10.6142 18.3333C10.6142 18.2602 10.6334 18.1883 10.67 18.125L14.6392 11.25C14.6757 11.1867 14.7283 11.1341 14.7917 11.0975C14.855 11.0609 14.9269 11.0417 15 11.0417C15.0731 11.0417 15.145 11.0609 15.2083 11.0975C15.2717 11.1341 15.3243 11.1867 15.3608 11.25V11.25ZM14.5833 16.6667V17.5H15.4167V16.6667H14.5833ZM14.5833 13.75V15.8333H15.4167V13.75H14.5833Z"
      fill="#FF9B38"
    />
    <defs>
      <clipPath id="clip0_7_33">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default React.memo(AlertFilterLine);
